import { render, staticRenderFns } from "./PC-versioning.vue?vue&type=template&id=57d924fe"
import script from "./PC-versioning.vue?vue&type=script&lang=js"
export * from "./PC-versioning.vue?vue&type=script&lang=js"
import style0 from "./PC-versioning.vue?vue&type=style&index=0&id=57d924fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports